<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
          :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput" @onSelect="onSelect" />

        <div v-if="detail.reject_reason && detail.is_status != 4">
          <FormItem :viewMode="true" :config="rejectCtrl" :inputValue="detail['reject_reason']" @onChange="onChange" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <el-button v-if="mode != 'view'" type="primary" @click="onSubmit">
        提 交
      </el-button>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保列表", path: `/fix/list` },
        { name: "维保记录详情" },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      // .el-input,
      .el-date-editor--daterange {
        width: auto;
        width: 300px;
      }

      .el-input.showUpload {
        width: auto;
      }

      // .el-form-item__content {
        .el-input {
          width: auto;
          width: 300px;
        }

        .el-textarea {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      // }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;

  .reject {
    background: #FF4541;
    border-color: #FF4541;
  }

  .examine {
    background: #0fc4b1;
    border-color: #0fc4b1;
  }
}
</style>
